import { render } from "./RecommendCourse.vue?vue&type=template&id=136d46e2&scoped=true&ts=true"
import script from "./RecommendCourse.vue?vue&type=script&lang=ts"
export * from "./RecommendCourse.vue?vue&type=script&lang=ts"

import "./RecommendCourse.vue?vue&type=style&index=0&id=136d46e2&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136d46e2"]])

export default __exports__